import { CardRenderer } from '@/components/elements/Card';
import { EmblaCarousel } from '@/components/elements/Carousel/Carousel';
import Container from '@/components/global/Container';
import { TitleAndDescription } from '@/components/shared/TitleAndDescription';
import { ICardEntity, IComponentBlocksCarouselBlock, IComponentSharedTitleAndDescription } from '@/graphql/__generated__/global/types';
import { determineCardSpan } from '@/helpers/determineCardSpan';

export const BlocksCarousel = ({ titleDescription, slidesPerView, cards }: IComponentBlocksCarouselBlock) => {
    return (
        <>
            {titleDescription && (
                <Container>
                    <TitleAndDescription {...(titleDescription as IComponentSharedTitleAndDescription)} />
                </Container>
            )}
            <Container paddingX={false} maxWidth="xl">
                <EmblaCarousel
                    emblaOptions={{
                        slidesToScroll: 'auto',
                        containScroll: 'trimSnaps',
                    }}
                >
                    {({ emblaRef, scrollSnaps, scrollTo, scrollProgress, scrollNext, scrollPrev }) => {
                        return (
                            <>
                                <EmblaCarousel.Slides ref={emblaRef} className={`embla__carousel slide-width--${slidesPerView.toLowerCase()}`}>
                                    {cards &&
                                        cards.data?.length > 0 &&
                                        cards.data?.map((card, index) => {
                                            const { image, eyebrowText, title, description, link, tintImage } = card.attributes?.Card ?? {};

                                            return (
                                                <div className="embla__slide" key={index}>
                                                    <CardRenderer
                                                        card={{
                                                            image,
                                                            eyebrowText,
                                                            title,
                                                            description,
                                                            link,
                                                            tintImage,
                                                            sizes: `(max-width: 767px) 85vw, (max-width: 1919px) 50vw, 928px`,
                                                        }}
                                                        span={determineCardSpan(cards.data as ICardEntity[], card as ICardEntity, slidesPerView)}
                                                    />
                                                </div>
                                            );
                                        })}
                                </EmblaCarousel.Slides>
                                <Container maxWidth="xl">
                                    <EmblaCarousel.ProgressBar max={scrollSnaps.length} scrollTo={scrollTo} scrollProgress={scrollProgress} scrollNext={scrollNext} scrollPrev={scrollPrev} />
                                </Container>
                            </>
                        );
                    }}
                </EmblaCarousel>
            </Container>
        </>
    );
};

export default BlocksCarousel;
